// Vendor App JS - Main entry point for all vendor JavaScript functionality

import {debug} from "@/debug.js";

// Import toast functionality
import './toast.js';

// Import ticket show functionality
import './ticket-show.js';

// Import product prices list functionality
import './product-prices-list.js';

// Dashboard menu functionality - Using event delegation for SPA compatibility
// Use document-level event delegation so it works even after navigation
function handleMenuClick(e) {
  const clickTarget = e.target instanceof Element ? e.target : null;
  if (!clickTarget) return;

  // Check if clicked element is a parent menu item
  const parentItem = clickTarget.closest('.vendor-nav-parent');
  if (!parentItem) return;

  // Make sure we're inside the vendor sidebar
  const sidebarNav = parentItem.closest('.vendor-sidebar-nav');
  if (!sidebarNav) return;

  e.preventDefault();
  e.stopPropagation();
  
  const group = parentItem.closest('.vendor-nav-group');
  if (!group) return;
  
  // Close other open menus only in this sidebar
  sidebarNav.querySelectorAll('.vendor-nav-group').forEach(otherGroup => {
    if (otherGroup !== group) {
      otherGroup.classList.remove('active');
    }
  });
  
  // Toggle current menu
  group.classList.toggle('active');
}

// Store handler reference globally for cleanup
if (!window.vendorMenuGlobalHandler) {
  window.vendorMenuGlobalHandler = handleMenuClick;
  // Use capture so Livewire/component handlers cannot block this menu handler.
  document.addEventListener('click', window.vendorMenuGlobalHandler, true);
}

function initVendorMenu() {
  // Auto-open submenu if one of its items is active
  const sidebarNav = document.querySelector('.vendor-sidebar-nav');
  if (!sidebarNav) return;
  
  const activeSubitem = sidebarNav.querySelector('.vendor-nav-subitem.active');
  if (activeSubitem) {
    const group = activeSubitem.closest('.vendor-nav-group');
    if (group) {
      group.classList.add('active');
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVendorMenu);
} else {
  initVendorMenu();
}

// Re-initialize on Livewire navigation (for SPA mode)
function reinitMenu() {
  // Use a longer delay to ensure DOM is fully updated
  setTimeout(function() {
    initVendorMenu();
    // Also auto-open active submenus after navigation
    const sidebarNav = document.querySelector('.vendor-sidebar-nav');
    if (sidebarNav) {
      const activeSubitem = sidebarNav.querySelector('.vendor-nav-subitem.active');
      if (activeSubitem) {
        const group = activeSubitem.closest('.vendor-nav-group');
        if (group) {
          group.classList.add('active');
        }
      }
    }
  }, 300);
}

// Listen to both Livewire and Alpine navigation events
document.addEventListener('livewire:navigated', reinitMenu);
document.addEventListener('alpine:navigated', reinitMenu);

// Also listen for Livewire load
if (window.Livewire) {
  document.addEventListener('livewire:load', initVendorMenu);
}

// Theme Toggle functionality - Moved to inline script in layout for better compatibility

// Add other vendor JS modules here as needed
// import './other-module.js';

debug.log('Vendor app.js loaded');
